import React, { useRef } from 'react'
import { useLoad } from '../hooks/load'
import { sanitizeIconSVG } from '../svg/sanitize-svg'
import { IconProvider } from '../icon/icon'

// One sanitised SVG, assigned to innerHTML the way the sign-in page's
// provider buttons render it (login-provider.js).
export const IconSVG = ({ svg, className }) => {
  const ref = useRef(null)
  const clean = svg ? sanitizeIconSVG(svg) : ''
  useLoad(() => { if (ref.current) ref.current.innerHTML = clean }, [clean])
  return clean ? <span ref={ref} className={className} /> : null
}

// The provider logo tile in the workspace header. Driven by the connection's
// own iconSVG, rendered the way the sign-in page's provider buttons render it
// (login-provider.js: sanitised, then assigned to innerHTML); without one, the
// admin's generic provider icon. Never derived from the provider's name.
export const ProviderLogo = ({ iconSVG }) => {
  const ref = useRef(null)
  const svg = iconSVG ? sanitizeIconSVG(iconSVG) : ''
  useLoad(() => { if (ref.current) ref.current.innerHTML = svg }, [svg])
  return (
    <div className="sw-logo" aria-hidden="true" data-testid="sw-logo">
      {svg ? <span ref={ref} className="sw-logo-svg" /> : <IconProvider />}
    </div>
  )
}
